import type { JSX } from 'react';
import type { CSSProperties, ReactNode } from 'react';

export interface ChipProps {
  /** Выбран — оранжевая рамка, мягкая оранжевая подложка, оранжевый текст. */
  active?: boolean;
  onClick?: () => void;
  icon?: ReactNode;
  /** Счётчик справа («Активные 12»). */
  count?: number | string | null;
  /**
   * md — чип фильтра `_ds` (6×12, 13 px); sm — плотный чип каркаса CRM v2
   * (PChip: 5×11, 12 px) для рядов чипов в узких колонках.
   */
  size?: 'sm' | 'md';
  disabled?: boolean;
  title?: string;
  'aria-label'?: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

/**
 * Чип фильтра (порт `_ds/components/Chip` + PChip каркаса CRM v2): радиус 8,
 * 600, активный — оранжевый. Кнопка с `aria-pressed` — несколько чипов можно
 * включать независимо; для «одного из» есть `Seg` (или старые `design/Chips`).
 */
export function Chip({
  active = false,
  onClick,
  icon,
  count,
  size = 'md',
  disabled,
  title,
  className,
  style,
  children,
  ...aria
}: ChipProps): JSX.Element {
  const cls = ['fk-ds-chip', size === 'sm' ? 'fk-ds-chip--sm' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <button
      type="button"
      className={cls}
      aria-pressed={active}
      aria-label={aria['aria-label']}
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={style}
    >
      {icon}
      {children}
      {count != null && count !== '' ? <span className="fk-ds-chip-count">{count}</span> : null}
    </button>
  );
}
